<app-modal-header [hasClose]='true' [title]="title" (handleClose)="close()"></app-modal-header>

<mat-dialog-content class="content-dialog">

  @if (data.action != 2) {
    <span>{{dialogMessage}}</span>
  }

  <mat-list>
    <div mat-subheader>Aluno(s) selecionado(s):</div>
    @for (item of data.itens; track item) {
      <mat-list-item>
        <mat-icon mat-list-icon>person</mat-icon>
        <div mat-line>{{ item.name }}</div>
        <div mat-line>CPF: {{ item.cpf_number }} </div>
      </mat-list-item>
    }
  </mat-list>

  @if (data.action == 2) {
    <div>
      <form [formGroup]="homologForm">
        <mat-form-field class="half-input">
          <input type="text" [formControl]="myReasonControl" placeholder="Justificativa" aria-label="Justificativa" matInput
            [matAutocomplete]="autoReason" (keyup)="validControl()">
            <mat-autocomplete #autoReason="matAutocomplete" [displayWith]="displayFnReason" matSelect placeholder="Escolha o motivo" (optionSelected)="validControl()">
              @for (item of filteredOptionsReason | async; track item) {
                <mat-option [value]="item">
                  {{item.description}}
                </mat-option>
              }
            </mat-autocomplete>
            @if (homologForm.get('reason_not_homologated_id').errors && homologForm.get('reason_not_homologated_id').touched) {
              <mat-hint>
              {{homologForm.get('reason_not_homologated_id').errors['message']}}</mat-hint>
            }
          </mat-form-field>
        </form>
      </div>
    }

  </mat-dialog-content>

  <div class="modal-footer">

    <button mat-raised-button mat-dialog-close type="button" id="cancel">Cancelar</button>
    @if (data.action != 2) {
      <button mat-raised-button class="primary-action-btn" type="submit" (click)="homologation()">Confirmar</button>
    }
    @if (data.action == 2) {
      <button id="modalApplyBtn" mat-raised-button class="primary-action-btn" type="submit" [disabled]="homologForm.invalid" (click)="homologation()">Confirmar</button>
    }

  </div>
